import { useEffect, useState, useCallback } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Card,
  Checkbox,
  Container,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormControlLabel,
  Grid,
  IconButton,
  MenuItem,
  Select,
  Stack,
  tableCellClasses,
  TextField,
  Tooltip,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Box
} from '@mui/material';
import { styled } from '@mui/material/styles';
import CancelIcon from '@mui/icons-material/Cancel';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { AiOutlineMinus } from 'react-icons/ai';
import { MdOutlineAdd } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';

import BrudCrumbs from '../../components/BreadCrumbs';
import Page from '../../components/Page';
import PageTitle from '../../components/PageHeading';
import ApiErrorMessage from '../Global/ApiErrorMessage';
import { NOT_AVAILABLE } from '../Global/Constants';
import Loader from '../Global/Loader';
import { CommonApiforJourney } from '../services/RecommendationApi';
import CallCenterService from '../services/CallCenterService';
import useLoginSelector from '../../store/Slice/Login/LoginSelector';

const { GetAllAssignableStatuses, UpdateStatus } = CallCenterService;

const StyledTableRow = styled(TableRow)(() => ({
  backgroundColor: '#fff',
  '&:nth-of-type(even)': {
    backgroundColor: '#fafbfc'
  },
  '&:hover': {
    backgroundColor: '#f1f5f9 !important'
  },
  '&:last-child td, &:last-child th': {
    border: 0
  }
}));

const StyledTableCell = styled(TableCell)(() => ({
  [`&.${tableCellClasses.head}`]: {
    fontSize: 12,
    fontWeight: '700',
    padding: '14px 12px',
    color: '#637381',
    textTransform: 'uppercase',
    backgroundColor: '#f8fafc',
    borderBottom: '1px solid #e2e8f0'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 13,
    padding: '12px',
    borderBottom: '1px solid #f4f6f8'
  }
}));

export default function UpdateDisburse() {
  const navigate = useNavigate();
  const [openAppointment, setOpenAppointment] = useState({ status: false, indexVal: null });
  const [openFollowUp, setOpenFollowUp] = useState({ status: false, indexVal: null });
  const [updateStatusList, setUpdateStatusList] = useState([]);
  const [selectedItemList, setSelectedItemList] = useState([]);
  const [openApiError, setOpenApiError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [dialogOpen, setDialogOpen] = useState(false);
  const [validationMsg, setValidationMsg] = useState('');
  const [openLoader, setOpenLoader] = useState(false);

  const { LoginData } = useLoginSelector();

  const handleStatus = (e, index) => {
    const selectedValue = e.target.value;
    try {
      const parsed = JSON.parse(selectedValue);
      if (parsed.stageStatusName.toLowerCase() === 'disbursed') {
        setOpenFollowUp({ status: true, indexVal: index });
      } else if (parsed.stageStatusName.toLowerCase() === 'encashment') {
        setOpenAppointment({ status: true, indexVal: index });
      }
    } catch (err) {
      console.error(err);
    }
    const prevArray = [...selectedItemList];
    prevArray[index].status = selectedValue;
    setSelectedItemList(prevArray);
  };

  const handleFollowUpSubmit = (e, indexVal) => {
    if (selectedItemList[indexVal]?.disbursementDisburseDetailsModel?.disbursedAmount === '') {
      setDialogOpen(true);
      setValidationMsg('Please enter disbursed amount');
      return;
    } else if (
      selectedItemList[indexVal]?.disbursementDisburseDetailsModel
        ?.disbursementDisburseDocumentsDetailsModelList?.length < 1
    ) {
      setDialogOpen(true);
      setValidationMsg('Please upload supporting document');
      return;
    }
    const prevArray = [...selectedItemList];
    prevArray[indexVal].disbursementDisburseDetailsModel.isSubmitClicked = true;
    setSelectedItemList(prevArray);
    setOpenFollowUp({ status: false, indexVal: null });
  };

  const handleAppointmentSubmit = (e, indexVal) => {
    let loanTypeValidate = true;
    const currentDate = new Date();
    currentDate.setDate(currentDate.getDate() - 1);
    if (
      !selectedItemList[openAppointment.indexVal]?.encashmentDisburseDetailsModel?.remarks &&
      selectedItemList[indexVal]?.encashmentDisburseDetailsModel?.encashmentAmount === ''
    ) {
      setDialogOpen(true);
      setValidationMsg('Please enter encashment amount');
      loanTypeValidate = false;
    } else if (
      selectedItemList[indexVal]?.encashmentDisburseDetailsModel
        ?.encashmentDisburseDocumentsDetailsModels?.length < 1
    ) {
      setDialogOpen(true);
      setValidationMsg('Please upload supporting document');
      loanTypeValidate = false;
    } else if (
      selectedItemList[openAppointment.indexVal]?.encashmentDisburseDetailsModel?.remarks
    ) {
      selectedItemList[
        openAppointment.indexVal
      ]?.encashmentDisburseDetailsModel?.partialEncashmentDisburseDetailsModelList?.every(
        (itemValidate) => {
          if (
            itemValidate.partialEncashmentDate === null ||
            itemValidate.partialEncashmentDate === ''
          ) {
            setDialogOpen(true);
            setValidationMsg('Please enter date');
            loanTypeValidate = false;
          } else if (itemValidate.partialAmount === null || itemValidate.partialAmount === '') {
            setDialogOpen(true);
            setValidationMsg('Please enter encashment partial amount');
            loanTypeValidate = false;
          } else if (itemValidate.remarks === null || itemValidate.remarks === '') {
            setDialogOpen(true);
            setValidationMsg('Please enter remarks');
            loanTypeValidate = false;
          } else if (currentDate > new Date(itemValidate.partialEncashmentDate)) {
            setDialogOpen(true);
            setValidationMsg('Please enter valid encashment date');
            loanTypeValidate = false;
          }
          return loanTypeValidate;
        }
      );
    }

    if (loanTypeValidate === true) {
      const prevArray = [...selectedItemList];
      prevArray[indexVal].encashmentDisburseDetailsModel.isSubmitClicked = true;
      setSelectedItemList(prevArray);
      setOpenAppointment({ status: false, indexVal: null });
    }
  };

  const handleFollowUpCloseIcon = () => {
    const prevArray = [...selectedItemList];
    if (
      prevArray[openFollowUp.indexVal]?.disbursementDisburseDetailsModel?.disbursedAmount !== '' &&
      prevArray[openFollowUp.indexVal]?.disbursementDisburseDetailsModel?.isSubmitClicked
    ) {
      setOpenFollowUp({ status: false, indexVal: null });
    } else {
      prevArray[openFollowUp.indexVal].status = ' ';
      setSelectedItemList(prevArray);
      setOpenFollowUp({ status: false, indexVal: null });
    }
  };

  const handleAppointmentCloseIcon = () => {
    const prevArray = [...selectedItemList];
    if (
      prevArray[openAppointment.indexVal]?.encashmentDisburseDetailsModel?.encashmentAmount !==
        '' &&
      prevArray[openAppointment.indexVal]?.encashmentDisburseDetailsModel?.isSubmitClicked
    ) {
      setOpenAppointment({ status: false, indexVal: null });
    } else {
      prevArray[openAppointment.indexVal].status = ' ';
      setSelectedItemList(prevArray);
      setOpenAppointment({ status: false, indexVal: null });
    }
  };

  const handleUpdate = async () => {
    const objArray = [];
    selectedItemList.forEach((item) => {
      if (
        item.status !== ' ' &&
        JSON.parse(item.status).stageStatusName.toLowerCase() === 'disbursed'
      ) {
        const obj = {
          leadId: item.leadId,
          stageCode: 'DISBURSE',
          stageStatusId: JSON.parse(item.status).stageStatusId,
          userId: LoginData?.userId,
          disbursementDisburseDetailsModel: {
            disbursedAmount: item.disbursementDisburseDetailsModel.disbursedAmount,
            disbursementDisburseDocumentsDetailsModelList:
              item.disbursementDisburseDetailsModel.disbursementDisburseDocumentsDetailsModelList
          },
          comments: item.comments,
          applicationId: item.applicationId
        };
        objArray.push(obj);
      } else if (
        item.status !== ' ' &&
        JSON.parse(item.status).stageStatusName.toLowerCase() === 'encashment'
      ) {
        const encashment = item?.encashmentDisburseDetailsModel || {};

        const obj = {
          leadId: item.leadId,
          stageCode: 'DISBURSE',
          stageStatusId: JSON.parse(item.status).stageStatusId,
          userId: LoginData?.userId,
          encashmentDisburseDetailsModel: {
            encashmentAmount: encashment.encashmentAmount ?? null,
            encashmentDisburseDocumentsDetailsModels:
              encashment.encashmentDisburseDocumentsDetailsModels ?? [],
            partialEncashmentDisburseDetailsModelList: !encashment.encashmentAmount
              ? encashment.partialEncashmentDisburseDetailsModelList ?? []
              : []
          },
          comments: item.comments,
          applicationId: item.applicationId
        };
        objArray.push(obj);
      } else if (item.status !== ' ') {
        const obj = {
          leadId: item.leadId,
          stageCode: 'DISBURSE',
          stageStatusId: JSON.parse(item.status).stageStatusId,
          userId: LoginData?.userId,
          comments: item.comments,
          applicationId: item.applicationId
        };
        objArray.push(obj);
      }
    });

    if (objArray.length === selectedItemList.length) {
      const UpdateStatusApi = await UpdateStatus(objArray, LoginData?.jwt);
      if (UpdateStatusApi.status === 'success') {
        setSelectedItemList([]);
        navigate('/disburse');
      } else {
        setOpenApiError(true);
        setErrorMessage('Something went wrong !');
      }
    } else {
      setDialogOpen(true);
      setValidationMsg('Please select status');
    }
  };

  const uploadFileApiFire = async (type, condition, no, index) => {
    const companyIdObj = {
      companyId: LoginData?.companyId,
      userId: LoginData?.userId
    };
    const token = LoginData?.jwt;
    if (type === 'fileUpload') {
      const formData = new FormData();
      formData.append('companyId', companyIdObj.companyId);
      formData.append('userId', companyIdObj.userId);
      formData.append('applicationId ', index);
      formData.append('file ', condition);
      const methodName = 'POST';
      const endapiPath = 'file/uploadFile';
      uploadFileApiFireResponse(
        type,
        methodName,
        endapiPath,
        formData,
        token,
        'formdata',
        condition,
        no
      );
    }
  };

  const uploadFileApiFireResponse = async (
    type,
    method,
    endpoint,
    credentials,
    authToken,
    frmData,
    condition,
    no
  ) => {
    setOpenLoader(true);
    const responseData = await CommonApiforJourney(
      method,
      endpoint,
      credentials,
      authToken,
      frmData
    );
    if (responseData.status === 'success' || responseData.action_status === 'success') {
      setOpenLoader(false);
      if (type === 'fileUpload') {
        const prevArray = [...selectedItemList];
        if (no === 'disbursed') {
          prevArray[
            openFollowUp.indexVal
          ].disbursementDisburseDetailsModel.disbursementDisburseDocumentsDetailsModelList.push({
            fileName: condition.name,
            savedName: responseData.data.fileDetails.name
          });
        } else {
          prevArray[
            openAppointment.indexVal
          ].encashmentDisburseDetailsModel.encashmentDisburseDocumentsDetailsModels.push({
            fileName: condition.name,
            savedName: responseData.data.fileDetails.name
          });
        }
        setSelectedItemList(prevArray);
      }
    } else {
      setOpenLoader(false);
      setOpenApiError(true);
      setErrorMessage('Something went wrong !');
    }
  };

  const loadData = useCallback(async () => {
    const localSelectedItem = JSON.parse(localStorage.getItem('selectedItem'));
    const stageCode = 'DISBURSE';
    const authToken = LoginData?.jwt;

    const GetAllAssignableStatusesApi = await GetAllAssignableStatuses(stageCode, authToken);
    if (GetAllAssignableStatusesApi.status === 'success') {
      GetAllAssignableStatusesApi.data.forEach((item) => {
        item.leadStatus = true;
        localSelectedItem?.forEach((listItem) => {
          if (
            listItem.status.toLowerCase() !== 'disbursed' &&
            item.stageStatusName.toLowerCase() === 'encashment'
          ) {
            item.leadStatus = false;
          } else if (
            listItem.status.toLowerCase() === 'encashment' &&
            item.stageStatusName.toLowerCase() === 'disbursed'
          ) {
            item.leadStatus = false;
          } else if (
            listItem.status.toLowerCase() === 'disbursed' &&
            item.stageStatusName.toLowerCase() === 'disbursed'
          ) {
            item.leadStatus = false;
          }
        });
      });

      setUpdateStatusList(GetAllAssignableStatusesApi.data);
    }

    if (localSelectedItem && localSelectedItem.length > 0) {
      localSelectedItem.forEach((item) => {
        item.status = ' ';
        item.comments = '';
        item.disbursementDisburseDetailsModel = {
          disbursedAmount: '',
          disbursementDisburseDocumentsDetailsModelList: []
        };
        item.encashmentDisburseDetailsModel = {
          encashmentAmount: '',
          encashmentDisburseDocumentsDetailsModels: [],
          partialEncashmentDisburseDetailsModelList: [
            {
              partialAmount: '',
              partialEncashmentDate: '',
              remarks: ''
            }
          ],
          remarks: false
        };
      });
      setSelectedItemList(localSelectedItem);
    } else {
      setSelectedItemList([]);
    }
  }, [LoginData]);

  useEffect(() => {
    loadData();
  }, [loadData]);

  useEffect(() => {
    setOpenLoader(true);
    if (selectedItemList.length > 0) {
      setOpenLoader(false);
    }
  }, [selectedItemList]);

  return (
    <Page title="Partner Management System || Disburse">
      <Container maxWidth="xl">
        <Box pt={3} pb={3} mb={4}>
          <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ mb: 3 }}>
            <PageTitle info="Update Disburse Status" />
            <Box>
              <BrudCrumbs />
            </Box>
          </Stack>

          <Card
            sx={{
              borderRadius: '20px',
              border: '1px solid #e2e8f0',
              boxShadow: '0 4px 14px rgba(0,0,0,0.03)',
              overflow: 'hidden',
              mb: 3
            }}
          >
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <TableHead>
                  <TableRow>
                    <StyledTableCell>Lead ID</StyledTableCell>
                    <StyledTableCell>Lead Name</StyledTableCell>
                    <StyledTableCell>Status</StyledTableCell>
                    <StyledTableCell>Comments</StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {selectedItemList.length > 0 ? (
                    selectedItemList.map((item, index) => (
                      <StyledTableRow key={index}>
                        <StyledTableCell sx={{ color: '#13519d', fontWeight: 600 }}>
                          {item.leadId ? item.leadId : `${NOT_AVAILABLE}`}
                        </StyledTableCell>
                        <StyledTableCell sx={{ fontWeight: 500, color: '#1e293b' }}>
                          {item.leadName ? item.leadName : `${NOT_AVAILABLE}`}
                        </StyledTableCell>
                        <StyledTableCell>
                          <Select
                            fullWidth
                            size="small"
                            value={item.status}
                            onChange={(e) => handleStatus(e, index)}
                            sx={{
                              minWidth: '220px',
                              borderRadius: '8px',
                              backgroundColor: '#f8fafc',
                              fontSize: '13px'
                            }}
                          >
                            <MenuItem value=" " disabled>
                              Select Status
                            </MenuItem>
                            {updateStatusList.length > 0 &&
                              updateStatusList.map((item1, index1) => (
                                <MenuItem
                                  disabled={!item1.leadStatus}
                                  value={JSON.stringify(item1)}
                                  key={index1}
                                  sx={{ fontSize: '13px' }}
                                >
                                  {item1.stageStatusName}
                                </MenuItem>
                              ))}
                          </Select>
                        </StyledTableCell>
                        <StyledTableCell>
                          <TextField
                            fullWidth
                            size="small"
                            placeholder="Write Your Comments"
                            sx={{
                              minWidth: '220px',
                              '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                                backgroundColor: '#f8fafc',
                                fontSize: '13px'
                              }
                            }}
                            value={item.comments}
                            onChange={(e) => {
                              const prevArray = [...selectedItemList];
                              prevArray[index].comments = e.target.value;
                              setSelectedItemList(prevArray);
                            }}
                          />
                        </StyledTableCell>
                      </StyledTableRow>
                    ))
                  ) : (
                    <TableRow>
                      <TableCell colSpan={4} align="center" sx={{ py: 4, color: '#94a3b8' }}>
                        No leads selected for update
                      </TableCell>
                    </TableRow>
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </Card>

          <Box textAlign="right">
            <Button
              variant="contained"
              onClick={handleUpdate}
              sx={{
                backgroundColor: '#13519d',
                color: '#ffffff',
                fontWeight: 600,
                borderRadius: '8px',
                textTransform: 'none',
                px: 4,
                py: 1.2,
                boxShadow: '0 4px 12px rgba(19, 81, 157, 0.2)',
                '&:hover': { backgroundColor: '#0d3b75' }
              }}
            >
              Update Status
            </Button>
          </Box>

          {/* Disbursed Dialog */}
          <Dialog
            open={openFollowUp.status}
            fullWidth
            maxWidth="sm"
            onClose={handleFollowUpCloseIcon}
            PaperProps={{
              sx: {
                borderRadius: '16px',
                overflow: 'hidden'
              }
            }}
          >
            <DialogTitle
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                pb: 1.5,
                borderBottom: '1px solid #f1f5f9'
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 700, color: '#1e293b' }}>
                Disbursed Details
              </Typography>
              <IconButton onClick={handleFollowUpCloseIcon} size="small" sx={{ color: '#94a3b8' }}>
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ pt: 2.5 }}>
              <Box mb={2.5}>
                <Typography
                  variant="caption"
                  sx={{
                    color: '#64748b',
                    fontWeight: 700,
                    textTransform: 'uppercase',
                    fontSize: '11px',
                    display: 'block',
                    mb: 1
                  }}
                >
                  Disbursed Amount *
                </Typography>
                <TextField
                  fullWidth
                  size="small"
                  placeholder="Enter Disbursed Amount"
                  value={
                    selectedItemList[openFollowUp.indexVal]?.disbursementDisburseDetailsModel
                      ?.disbursedAmount || ''
                  }
                  type="number"
                  onChange={(e) => {
                    const prevArray = [...selectedItemList];
                    prevArray[
                      openFollowUp.indexVal
                    ].disbursementDisburseDetailsModel.disbursedAmount = e.target.value;
                    setSelectedItemList(prevArray);
                  }}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: '8px',
                      backgroundColor: '#f8fafc'
                    }
                  }}
                />
              </Box>

              <Button
                variant="outlined"
                component="label"
                startIcon={<CloudUploadIcon />}
                sx={{
                  borderColor: '#13519d',
                  color: '#13519d',
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontWeight: 600,
                  mb: 2,
                  '&:hover': {
                    borderColor: '#0d3b75',
                    backgroundColor: 'rgba(19, 81, 157, 0.04)'
                  }
                }}
              >
                Upload Supporting Document
                <input
                  hidden
                  accept="image/png, image/gif, image/jpeg, image/jpg"
                  type="file"
                  onChange={(e) => {
                    const fileData = e.target.files[0];
                    if (fileData !== undefined) {
                      uploadFileApiFire(
                        'fileUpload',
                        fileData,
                        'disbursed',
                        selectedItemList[openFollowUp.indexVal].applicationId
                      );
                    }
                  }}
                />
              </Button>

              <Box
                sx={{
                  p: 2,
                  borderRadius: '10px',
                  backgroundColor: '#f8fafc',
                  border: '1px solid #e2e8f0'
                }}
              >
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#475569', mb: 1 }}>
                  Uploaded Documents
                </Typography>
                {selectedItemList[openFollowUp.indexVal]?.disbursementDisburseDetailsModel
                  ?.disbursementDisburseDocumentsDetailsModelList.length > 0 ? (
                  selectedItemList[
                    openFollowUp.indexVal
                  ]?.disbursementDisburseDetailsModel?.disbursementDisburseDocumentsDetailsModelList.map(
                    (fileTtem, fileTtemIndex) => (
                      <Stack
                        key={fileTtemIndex}
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                          py: 0.75,
                          px: 1.5,
                          mb: 0.75,
                          borderRadius: '6px',
                          backgroundColor: '#ffffff',
                          border: '1px solid #e2e8f0'
                        }}
                      >
                        <Typography variant="body2" sx={{ color: '#1e293b', fontSize: '13px' }}>
                          {fileTtem.fileName}
                        </Typography>
                        <IconButton
                          size="small"
                          sx={{ color: '#ef4444', p: 0.5 }}
                          onClick={() => {
                            const prevArray = [...selectedItemList];
                            prevArray[
                              openFollowUp.indexVal
                            ].disbursementDisburseDetailsModel.disbursementDisburseDocumentsDetailsModelList.splice(
                              fileTtemIndex,
                              1
                            );
                            setSelectedItemList(prevArray);
                          }}
                        >
                          <CancelIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Stack>
                    )
                  )
                ) : (
                  <Typography
                    variant="body2"
                    sx={{ color: '#94a3b8', fontStyle: 'italic', fontSize: '13px' }}
                  >
                    No Document Uploaded
                  </Typography>
                )}
              </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2.5, borderTop: '1px solid #f1f5f9' }}>
              <Button
                onClick={handleFollowUpCloseIcon}
                sx={{
                  borderRadius: '8px',
                  color: '#64748b',
                  textTransform: 'none',
                  fontWeight: 600
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={(e) => handleFollowUpSubmit(e, openFollowUp.indexVal)}
                variant="contained"
                sx={{
                  backgroundColor: '#13519d',
                  color: '#ffffff',
                  fontWeight: 600,
                  borderRadius: '8px',
                  textTransform: 'none',
                  px: 3,
                  '&:hover': { backgroundColor: '#0d3b75' }
                }}
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>

          {/* Encashment Dialog */}
          <Dialog
            open={openAppointment.status}
            fullWidth
            maxWidth="md"
            onClose={handleAppointmentCloseIcon}
            PaperProps={{
              sx: {
                borderRadius: '16px',
                overflow: 'hidden'
              }
            }}
          >
            <DialogTitle
              sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                pb: 1.5,
                borderBottom: '1px solid #f1f5f9'
              }}
            >
              <Typography variant="h6" sx={{ fontWeight: 700, color: '#1e293b' }}>
                Encashment Details
              </Typography>
              <IconButton
                onClick={handleAppointmentCloseIcon}
                size="small"
                sx={{ color: '#94a3b8' }}
              >
                <CloseIcon />
              </IconButton>
            </DialogTitle>
            <DialogContent sx={{ pt: 2.5 }}>
              {!selectedItemList[openAppointment.indexVal]?.encashmentDisburseDetailsModel
                ?.remarks && (
                <Box mb={2.5}>
                  <Typography
                    variant="caption"
                    sx={{
                      color: '#64748b',
                      fontWeight: 700,
                      textTransform: 'uppercase',
                      fontSize: '11px',
                      display: 'block',
                      mb: 1
                    }}
                  >
                    Encashment Amount *
                  </Typography>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Enter Encashment Amount"
                    value={
                      selectedItemList[openAppointment.indexVal]?.encashmentDisburseDetailsModel
                        ?.encashmentAmount || ''
                    }
                    onChange={(e) => {
                      const prevArray = [...selectedItemList];
                      if (/^\d+$/.test(e.target.value.trim())) {
                        prevArray[
                          openAppointment.indexVal
                        ].encashmentDisburseDetailsModel.encashmentAmount = e.target.value;
                      } else {
                        prevArray[
                          openAppointment.indexVal
                        ].encashmentDisburseDetailsModel.encashmentAmount = '';
                      }
                      setSelectedItemList(prevArray);
                    }}
                    sx={{
                      '& .MuiOutlinedInput-root': {
                        borderRadius: '8px',
                        backgroundColor: '#f8fafc'
                      }
                    }}
                  />
                </Box>
              )}

              <Box mb={2}>
                <FormControlLabel
                  checked={
                    selectedItemList[openAppointment.indexVal]?.encashmentDisburseDetailsModel
                      ?.remarks || false
                  }
                  onChange={() => {
                    const prevArray = [...selectedItemList];
                    prevArray[openAppointment.indexVal].encashmentDisburseDetailsModel.remarks =
                      !prevArray[openAppointment.indexVal].encashmentDisburseDetailsModel.remarks;
                    prevArray[
                      openAppointment.indexVal
                    ].encashmentDisburseDetailsModel.encashmentAmount = '';
                    setSelectedItemList(prevArray);
                  }}
                  control={
                    <Checkbox
                      size="small"
                      sx={{ color: '#13519d', '&.Mui-checked': { color: '#13519d' } }}
                    />
                  }
                  label={
                    <Typography variant="body2" sx={{ fontWeight: 600, color: '#334155' }}>
                      Partial Encashment Allowed
                    </Typography>
                  }
                />
              </Box>

              {selectedItemList[openAppointment.indexVal]?.encashmentDisburseDetailsModel
                ?.remarks &&
                selectedItemList[
                  openAppointment.indexVal
                ]?.encashmentDisburseDetailsModel?.partialEncashmentDisburseDetailsModelList?.map(
                  (addItem, addItemIndex) => (
                    <Grid key={addItemIndex} container spacing={2} mb={2} alignItems="center">
                      <Grid item xs={12} sm={3.5}>
                        <TextField
                          fullWidth
                          size="small"
                          type="date"
                          value={addItem.partialEncashmentDate || ''}
                          onChange={(e) => {
                            const prevArray = [...selectedItemList];
                            prevArray[
                              openAppointment.indexVal
                            ].encashmentDisburseDetailsModel.partialEncashmentDisburseDetailsModelList[
                              addItemIndex
                            ].partialEncashmentDate = e.target.value;
                            setSelectedItemList(prevArray);
                          }}
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '8px',
                              backgroundColor: '#f8fafc'
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3.5}>
                        <TextField
                          fullWidth
                          size="small"
                          value={addItem.partialAmount || ''}
                          onChange={(e) => {
                            const prevArray = [...selectedItemList];
                            if (/^\d+$/.test(e.target.value.trim())) {
                              prevArray[
                                openAppointment.indexVal
                              ].encashmentDisburseDetailsModel.partialEncashmentDisburseDetailsModelList[
                                addItemIndex
                              ].partialAmount = e.target.value;
                            } else {
                              prevArray[
                                openAppointment.indexVal
                              ].encashmentDisburseDetailsModel.partialEncashmentDisburseDetailsModelList[
                                addItemIndex
                              ].partialAmount = '';
                            }
                            setSelectedItemList(prevArray);
                          }}
                          placeholder="Amount"
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '8px',
                              backgroundColor: '#f8fafc'
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={3.5}>
                        <TextField
                          fullWidth
                          size="small"
                          value={addItem.remarks || ''}
                          onChange={(e) => {
                            const prevArray = [...selectedItemList];
                            prevArray[
                              openAppointment.indexVal
                            ].encashmentDisburseDetailsModel.partialEncashmentDisburseDetailsModelList[
                              addItemIndex
                            ].remarks = e.target.value;
                            setSelectedItemList(prevArray);
                          }}
                          placeholder="Remarks"
                          sx={{
                            '& .MuiOutlinedInput-root': {
                              borderRadius: '8px',
                              backgroundColor: '#f8fafc'
                            }
                          }}
                        />
                      </Grid>
                      <Grid item xs={12} sm={1.5} textAlign="center">
                        {addItemIndex === 0 ? (
                          <Tooltip title="Add Partial Row" placement="top" arrow>
                            <IconButton
                              onClick={() => {
                                const prevArray = [...selectedItemList];
                                prevArray[
                                  openAppointment.indexVal
                                ]?.encashmentDisburseDetailsModel?.partialEncashmentDisburseDetailsModelList?.push(
                                  {
                                    partialAmount: '',
                                    partialEncashmentDate: '',
                                    remarks: ''
                                  }
                                );
                                setSelectedItemList(prevArray);
                              }}
                              sx={{
                                backgroundColor: 'rgba(19, 81, 157, 0.08)',
                                color: '#13519d',
                                borderRadius: '8px',
                                '&:hover': { backgroundColor: 'rgba(19, 81, 157, 0.16)' }
                              }}
                            >
                              <MdOutlineAdd size={18} />
                            </IconButton>
                          </Tooltip>
                        ) : (
                          <Tooltip title="Remove Row" placement="top" arrow>
                            <IconButton
                              onClick={() => {
                                const prevArray = [...selectedItemList];
                                prevArray[
                                  openAppointment.indexVal
                                ]?.encashmentDisburseDetailsModel?.partialEncashmentDisburseDetailsModelList?.splice(
                                  addItemIndex,
                                  1
                                );
                                setSelectedItemList(prevArray);
                              }}
                              sx={{
                                backgroundColor: '#fee2e2',
                                color: '#ef4444',
                                borderRadius: '8px',
                                '&:hover': { backgroundColor: '#fecaca' }
                              }}
                            >
                              <AiOutlineMinus size={18} />
                            </IconButton>
                          </Tooltip>
                        )}
                      </Grid>
                    </Grid>
                  )
                )}

              <Button
                variant="outlined"
                component="label"
                startIcon={<CloudUploadIcon />}
                sx={{
                  borderColor: '#13519d',
                  color: '#13519d',
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontWeight: 600,
                  mb: 2,
                  mt: 1,
                  '&:hover': {
                    borderColor: '#0d3b75',
                    backgroundColor: 'rgba(19, 81, 157, 0.04)'
                  }
                }}
              >
                Upload Supporting Document
                <input
                  hidden
                  accept="image/png, image/gif, image/jpeg, image/jpg"
                  type="file"
                  onChange={(e) => {
                    const fileData = e.target.files[0];
                    if (fileData !== undefined) {
                      uploadFileApiFire(
                        'fileUpload',
                        fileData,
                        'encashment',
                        selectedItemList[openAppointment.indexVal].applicationId
                      );
                    }
                  }}
                />
              </Button>

              <Box
                sx={{
                  p: 2,
                  borderRadius: '10px',
                  backgroundColor: '#f8fafc',
                  border: '1px solid #e2e8f0'
                }}
              >
                <Typography variant="subtitle2" sx={{ fontWeight: 700, color: '#475569', mb: 1 }}>
                  Uploaded Documents
                </Typography>
                {selectedItemList[openAppointment.indexVal]?.encashmentDisburseDetailsModel
                  ?.encashmentDisburseDocumentsDetailsModels?.length > 0 ? (
                  selectedItemList[
                    openAppointment.indexVal
                  ]?.encashmentDisburseDetailsModel?.encashmentDisburseDocumentsDetailsModels.map(
                    (fileTtem, fileTtemIndex) => (
                      <Stack
                        key={fileTtemIndex}
                        direction="row"
                        alignItems="center"
                        justifyContent="space-between"
                        sx={{
                          py: 0.75,
                          px: 1.5,
                          mb: 0.75,
                          borderRadius: '6px',
                          backgroundColor: '#ffffff',
                          border: '1px solid #e2e8f0'
                        }}
                      >
                        <Typography variant="body2" sx={{ color: '#1e293b', fontSize: '13px' }}>
                          {fileTtem.fileName}
                        </Typography>
                        <IconButton
                          size="small"
                          sx={{ color: '#ef4444', p: 0.5 }}
                          onClick={() => {
                            const prevArray = [...selectedItemList];
                            prevArray[
                              openAppointment.indexVal
                            ].encashmentDisburseDetailsModel.encashmentDisburseDocumentsDetailsModels.splice(
                              fileTtemIndex,
                              1
                            );
                            setSelectedItemList(prevArray);
                          }}
                        >
                          <CancelIcon sx={{ fontSize: 18 }} />
                        </IconButton>
                      </Stack>
                    )
                  )
                ) : (
                  <Typography
                    variant="body2"
                    sx={{ color: '#94a3b8', fontStyle: 'italic', fontSize: '13px' }}
                  >
                    No Document Uploaded
                  </Typography>
                )}
              </Box>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2.5, borderTop: '1px solid #f1f5f9' }}>
              <Button
                onClick={handleAppointmentCloseIcon}
                sx={{
                  borderRadius: '8px',
                  color: '#64748b',
                  textTransform: 'none',
                  fontWeight: 600
                }}
              >
                Cancel
              </Button>
              <Button
                onClick={(e) => handleAppointmentSubmit(e, openAppointment.indexVal)}
                variant="contained"
                sx={{
                  backgroundColor: '#13519d',
                  color: '#ffffff',
                  fontWeight: 600,
                  borderRadius: '8px',
                  textTransform: 'none',
                  px: 3,
                  '&:hover': { backgroundColor: '#0d3b75' }
                }}
              >
                Submit
              </Button>
            </DialogActions>
          </Dialog>

          <ApiErrorMessage
            openApiError={openApiError}
            setOpenApiError={setOpenApiError}
            errorMessage={errorMessage}
          />
          <Loader openLoader={openLoader} />

          <Dialog
            open={dialogOpen}
            onClose={() => setDialogOpen(false)}
            PaperProps={{
              sx: {
                borderRadius: '16px',
                p: 1
              }
            }}
          >
            <DialogContent>
              <DialogContentText sx={{ color: '#1e293b', fontWeight: 500 }}>
                {validationMsg}
              </DialogContentText>
            </DialogContent>
            <DialogActions>
              <Button
                onClick={() => setDialogOpen(false)}
                variant="contained"
                sx={{
                  backgroundColor: '#13519d',
                  color: '#ffffff',
                  fontWeight: 600,
                  borderRadius: '8px',
                  textTransform: 'none',
                  px: 2.5,
                  '&:hover': { backgroundColor: '#0d3b75' }
                }}
              >
                Okay
              </Button>
            </DialogActions>
          </Dialog>
        </Box>
      </Container>
    </Page>
  );
}
